import Instance from './interceptor';
import { API } from '../constants/Constants';
import Toast from '../components/pages/utils/Toast';

export const getCheckedDataFields = async (type) => {
  try {
    const response = await Instance.post(API.GET_CHECKED_DATA_FIELDS, { type });
    console.log('🚀 ~ getCheckedDataFields ~ response:', response);
    if (response) {
      return response?.data?.checkedDataFields;
    }
  } catch (error) {
    Toast({ message: error?.response?.data?.message, variant: 'error' });
  }
};

export const getAnnotationData = async (id) => {
  try {
    const response = await Instance.get(`${API.ANNOTATION_DOC}/${id}`);
    return response?.data?.document?.document;
  } catch (error) {
    if (error?.response) {
      Toast({ message: error?.response?.data?.message, variant: 'error' });
    }
  }
};

export const validateDoc = async (data, id) => {
  try {
    return await Instance.patch(`${API.ANNOTATION_DOC}/${id}`, {
      annotation_data: data,
    });
  } catch (error) {
    Toast({ message: error?.response?.data?.message, variant: 'error' });
  }
};

export const getNewBoxAnnotationData = async (imageUrl, coordinates) => {
  const data = {
    coordinates: {
      image_url: imageUrl,
      coordinates,
    },
  };
  try {
    const response = await Instance.post(`${API.EXTRACT_API}`, data);
    return response?.data?.response;
  } catch (error) {
    Toast({ message: `${error?.message}`, variant: 'error' });
  }
};

export const postCurrencyConverter = async (
  fromCurrency,
  targetCurrency,
  amount,
) => {
  try {
    const convertedData = {
      fromCurrency,
      targetCurrency,
      amount,
    };
    const response = await Instance.post(
      `${API.CURRENCY_CONVERTED_DATA}`,
      convertedData,
    );
    if (response) {
      return response;
    }
    return response;
  } catch (error) {
    return error;
  }
};
